import React from 'react';
import { PAGES, THEMES } from 'common/const';

export const AppContext = React.createContext({
    page: PAGES.HOME,
    theme: THEMES.DEFAULT,
    changeTheme: () => {},
    changePage: () => {}
});
